var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-58734884"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 1,
    class: "avatar__icon"
};
var _hoisted_2 = {
    key: 2,
    class: "avatar__icon"
};
var _hoisted_3 = {
    key: 0,
    "aria-label": "online",
    class: "presence-dot"
};
var _hoisted_4 = {
    key: 1,
    "aria-label": "last-active",
    class: "presence-badge cursor-pointer"
};
import { computed } from 'vue';
import { getAvatarColors } from '@common/utils/Colors/Colors';
import EIcon from '@common/ui/EIcon.vue';
import { formatDate, numeralize } from '@common/utils/Format/Format';
import ETooltip from '@common/ui/ETooltip.vue';
export default /*#__PURE__*/ _defineComponent(__assign({ inheritAttrs: false }, { __name: 'EAvatar', props: {
        src: {},
        icon: {},
        colorId: { default: '3' },
        name: {},
        primary: { type: Boolean, default: false },
        mobile: { type: Boolean, default: false },
        lastActive: { default: null }
    }, setup: function (__props) {
        var props = __props;
        var avatarName = computed(function () { return props.name || 'A'; });
        var shortname = computed(function () {
            if (!avatarName.value)
                return '';
            return avatarName.value.trim().split(/\s+/)
                .map(function (word) { var _a; return ((_a = word[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || ''; })
                .slice(0, 2)
                .join('');
        });
        var bgColor = computed(function () {
            if (props.primary || props.src || !props.colorId)
                return '';
            return getAvatarColors(props.colorId)[0];
        });
        var textColor = computed(function () {
            if (props.primary)
                return '';
            if (!props.colorId)
                return '';
            return getAvatarColors(props.colorId)[1];
        });
        var hasPresence = computed(function () { return typeof props.lastActive === 'number' && !Number.isNaN(props.lastActive); });
        var diffMinutes = computed(function () {
            if (!hasPresence.value)
                return Infinity;
            return (Date.now() - props.lastActive) / (1000 * 60);
        });
        var isOnline = computed(function () { return diffMinutes.value < 15; });
        var lastActiveTooltip = computed(function () {
            if (!hasPresence.value)
                return '';
            return "\u0411\u044B\u043B(\u0430) \u043E\u043D\u043B\u0430\u0439\u043D ".concat(formatDate(props.lastActive, 'DD.MM.YY [в] HH:mm'));
        });
        var lastActiveLabel = computed(function () {
            var m = Math.floor(diffMinutes.value);
            if (m < 60)
                return "".concat(m, " \u043C\u0438\u043D");
            var h = Math.floor(m / 60);
            if (h < 24)
                return "".concat(h, " ").concat(numeralize(h, ['час', 'часа', 'часов']));
            var d = Math.floor(h / 24);
            if (d < 30)
                return "".concat(d, " ").concat(numeralize(d, ['день', 'дня', 'дней']));
            var mo = Math.floor(d / 30);
            if (mo < 12)
                return "".concat(mo, " \u043C\u0435\u0441");
            var y = Math.floor(mo / 12);
            return "".concat(y, " ").concat(numeralize(y, ['год', 'года', 'лет']));
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    hasPresence.value && 'relative'
                ])
            }, [
                _createElementVNode("div", _mergeProps({
                    class: [[
                            _ctx.primary ? 'hover:!bg-primary/30 !bg-primary/20' : '',
                            _ctx.mobile && 'avatar__mobile',
                        ], "avatar"],
                    style: { 'background-color': bgColor.value }
                }, _ctx.$attrs), [
                    (_ctx.src)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: _normalizeStyle({ 'background-image': 'url(' + _ctx.src + ')' }),
                            class: "avatar__image"
                        }, null, 4))
                        : (_ctx.icon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode(EIcon, {
                                    class: _normalizeClass({ '!text-primary': _ctx.primary }),
                                    icon: _ctx.icon
                                }, null, 8, ["class", "icon"])
                            ]))
                            : (!_ctx.name)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(EIcon, {
                                        class: _normalizeClass([{ '!text-primary': _ctx.primary, 'w-2.5 h-2.5': _ctx.mobile }, "w-5 h-5"]),
                                        icon: "image-stack"
                                    }, null, 8, ["class"])
                                ]))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 3,
                                    class: _normalizeClass([[
                                            { 'avatar__initials--smalltext': shortname.value.length === 2, '!text-primary': _ctx.primary }
                                        ], "avatar__initials"]),
                                    style: _normalizeStyle({ color: textColor.value })
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(shortname.value), 1)
                                ], 6))
                ], 16),
                (hasPresence.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (isOnline.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(ETooltip, {
                                    "tooltip-text": lastActiveTooltip.value,
                                    unselectable: ""
                                }, {
                                    default: _withCtx(function () { return [
                                        _createTextVNode(_toDisplayString(lastActiveLabel.value), 1)
                                    ]; }),
                                    _: 1
                                }, 8, ["tooltip-text"])
                            ]))
                    ], 64))
                    : _createCommentVNode("", true)
            ], 2));
        };
    } }));
